@if (showOrderingInformation) {
  <h2 class="help__heading">Ordering Support</h2>
  <p class="help__description">
    For further information about the ordering process, please see the help articles for
    <a ftrElevioTrigger articleId="9">ordering audio</a> and
    <a ftrElevioTrigger articleId="10">ordering transcripts</a>.
  </p>
  <p class="help__description">
    If you need help with amending and cancelling orders, status updates or required documentation, please contact the
    court directly.
  </p>
  @if (isLoggedIn) {
    <ftr-help-contact-details />
  }
}
